<template>
  <div class="uara-activity-view">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px" size="small">
      <div class="white-container">
        <el-form-item label="报名方式" prop="isTeamEvent">
          <el-radio-group v-model="form.isTeamEvent" :disabled="disabled">
            <el-radio :label="0">个人</el-radio>
            <el-radio :label="1">组队</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动类型" prop="uaraEventTypeId" style="width: 300px">
          <el-select v-model="form.uaraEventTypeId" placeholder="选择活动状态" :disabled="disabled">
            <el-option v-for="item in activityStatus" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="活动主标题" prop="name" style="width: 500px">
          <el-input v-model="form.name" placeholder="请输入活动主标题，最多不超过12个字" maxlength="12" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="活动城市" prop="uaEventCityId" style="width: 300px">
          <el-select ref="cityBox" v-model="form.uaEventCityId" placeholder="城市">
            <el-option v-for="item in citySelectVO" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 1 || form.uaraEventTypeId === 5" label="招募时间" prop="exportTime" style="width: 500px">
          <el-date-picker v-model="form.exportTime" type="daterange" placeholder="请选择招募时间" prefix-icon="el-icon-date" class="custom-date" start-placeholder="招募开始日期" end-placeholder="招募结束日期" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 1 " label="训练周期" prop="activityTime" style="width: 500px">
          <el-date-picker v-model="form.activityTime" type="datetimerange" placeholder="请选择训练周期" prefix-icon="el-icon-date" class="custom-date" start-placeholder="训练开始日期" end-placeholder="训练结束日期" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <div class="peopleNums">
          <el-form-item v-if=" form.uaraEventTypeId === 2 || form.uaraEventTypeId === 3 || form.uaraEventTypeId === 4" label="活动地址" prop="otherAddress" style="width: 500px">
            <el-input v-model="form.otherAddress" placeholder="请输入活动地址" :disabled="disabled" />
          </el-form-item>
          <div v-if=" form.uaraEventTypeId === 2 || form.uaraEventTypeId === 3 || form.uaraEventTypeId === 4" class="peopleNums-box">
            <el-button size="small" type="primary" @click="openMap">
              点开地图
            </el-button>
            <el-form-item label="坐标" prop="location" style="width: 300px" label-width="80px">
              <el-input v-model="form.location" placeholder="请输入活动地址的经纬度" :disabled="disabled" />
            </el-form-item>
          </div>
        </div>
        <el-form-item label="活动教练" prop="coachSelectVO" style="width: 100%">
          <CoachSelect v-model="form.coachSelectVO" :value.sync="form.coachSelectVO" :is-need-coach="form.isNeedCoach" @changeDisabled="handleChangeDisabled" />
        </el-form-item>

        <el-form-item v-if=" form.uaraEventTypeId === 2 || form.uaraEventTypeId === 3" label="活动时间" prop="activityTime" style="width: 500px">
          <el-date-picker v-model="form.activityTime" type="datetimerange" placeholder="请选择活动时间" prefix-icon="el-icon-date" class="custom-date" start-placeholder="活动开始日期和时间" end-placeholder="活动结束日期和时间" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 4 || form.uaraEventTypeId === 5" :label=" form.uaraEventTypeId === 4 ? '比赛日期' : '比赛时间' " prop="activityTime" style="width: 500px">
          <el-date-picker v-model="form.activityTime" type="datetimerange" placeholder="请选择比赛日期" prefix-icon="el-icon-date" class="custom-date" start-placeholder="比赛开始日期" end-placeholder="比赛结束日期" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <!-- 只有个人常规跑才有特邀 -->
        <el-form-item v-if="form.uaraEventTypeId === 3 && form.isTeamEvent === 0" label="是否为特邀" prop="isSpeciallyInvite">
          <el-radio-group v-model="form.isSpeciallyInvite" :disabled="disabled">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.uaraEventTypeId === 3 && form.isSpeciallyInvite === 0" label="是否进行二次筛选" prop="isSecondaryScreening">
          <el-radio-group v-model="form.isSecondaryScreening" :disabled="disabled">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="form.isTeamEvent === 1 && form.uaraEventTypeId !== 4" class="row-cont">
          <el-form-item v-if="form.uaraEventTypeId === 1 || form.uaraEventTypeId === 5" label="招募队伍数" prop="numberOfRecruits" style="width:300px">
            <el-input v-model.number="form.numberOfRecruits" type="number" placeholder="请输入招募队伍数" maxlength="9" @input="value => form.numberOfRecruits = parseInt(value)" />
          </el-form-item>
          <el-form-item label="报名队伍数" prop="teamNum" style="width:300px">
            <el-input v-model.number="form.teamNum" type="number" placeholder="请输入报名队伍数" maxlength="9" @input="value => form.teamNum = parseInt(value)" />
          </el-form-item>
        </div>
        <div v-if="form.isTeamEvent === 1 && form.uaraEventTypeId !== 4" class="row-cont">
          <el-form-item label="组队最大人数" prop="maxTeamPeople" style="width:300px">
            <el-input v-model.number="form.maxTeamPeople" type="number" placeholder="请输入组队最大人数" maxlength="9" @input="value => form.maxTeamPeople = parseInt(value)" />
          </el-form-item>
          <el-form-item label="组队最小人数" prop="minTeamPeople" style="width:300px">
            <el-input v-model.number="form.minTeamPeople" type="number" placeholder="请输入组队最小人数" maxlength="9" @input="value => form.minTeamPeople = parseInt(value)" @blur="checkMaxOrMinTeam('maxTeamPeople')" />
          </el-form-item>
        </div>
        <el-form-item v-if="form.uaraEventTypeId === 3 && form.isSpeciallyInvite === 1" label="上传用户名单" prop="excelName">
          <div class="coupon-upload flex">
            <div v-if="form.excelName" class="coupon_tip download-file" style="margin-right:10px">
              {{ form.excelName }}
            </div>
            <el-upload ref="uploader" class="uploader" action="" :show-file-list="false" :on-change="importCoupons" :auto-upload="false" :disabled="disabled">
              <el-button v-if="!form.excelName" size="small" type="primary">上传文件</el-button>
              <el-button v-else type="primary" size="small">重新上传</el-button>
            </el-upload>
            <div v-if="!form.excelName" class="coupon_tip upload_tips">仅支持上传*.xls、*.xlsx格式</div>
            <div v-if="!form.excelName" class="coupon_tip link-color download-template" style="margin-left:10px" @click="downloadFileTemplate">
              <i class="el-icon-document" />下载文件模板
            </div>
          </div>
        </el-form-item>
        <!-- 只有个人uara才有招募人数 候补人数这些 -->
        <div v-if="form.isTeamEvent === 0" class="peopleNums">
          <el-form-item v-if=" form.uaraEventTypeId === 1 || form.uaraEventTypeId === 5 || form.isSecondaryScreening === 1 " label="招募人数" prop="numberOfRecruits" style="width: 300px">
            <el-input v-model="form.numberOfRecruits" type="number" placeholder="请输入招募人数" :disabled="disabled" />
          </el-form-item>
          <el-form-item v-if="form.isSpeciallyInvite !== 1" ref="participationNumber" label="报名人数" prop="participationNumber" style="width: 300px">
            <el-input v-model="form.participationNumber" type="number" placeholder="请输入报名人数" :disabled="disabled" @change="changeParticipationNumber" />
          </el-form-item>
          <el-form-item v-if="form.isSpeciallyInvite !== 1" label="候补人数" prop="alternateTotalNumber" style="width: 300px">
            <el-input v-model="form.alternateTotalNumber" type="number" placeholder="请输入候补人数" :disabled="disabled" />
          </el-form-item>
        </div>
        <el-form-item v-if=" form.uaraEventTypeId === 1 " label="课程安排" prop="courseArrangementImg">
          <UploadImage :url="form.courseArrangementImg" title="课程安排图片" breadth="1005px" :save-path="savePath" :disabled="disabled" @upload="topUploader($event,'courseArrangementImg')" @triggerReg="handleCheckReg" />
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 1 " label="课程说明" prop="explanation" style="width: 80%">
          <el-input v-model="form.explanation" type="textarea" :rows="4" placeholder="请输入课程说明" :disabled="disabled" />
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 1 " label="备注" prop="remark" style="width: 80%">
          <el-input v-model="form.remark" type="textarea" :rows="4" placeholder="请输入备注" :disabled="disabled" />
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 1 " label="线下面试" prop="interview" style="width: 80%">
          <el-date-picker v-model="form.interview.offlineInterviewTime" type="date" placeholder="选择面试日期" format-date style="width:200px;margin-bottom:20px" value-format="yyyy-MM-dd HH:mm:ss" />
          <el-input v-model="form.interview.detailedDescription" type="textarea" :rows="4" placeholder="请输入详细描述" :disabled="disabled" />
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 5 " label="赛事规则" prop="competitionRules" style="width: 80%">
          <el-input v-model="form.competitionRules" type="textarea" :rows="4" placeholder="请输入赛事规则" :disabled="disabled" />
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 5 " label="注意事项" prop="precautions" style="width: 80%">
          <el-input v-model="form.precautions" type="textarea" :rows="4" placeholder="请输入注意事项" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="开放报名时间" prop="differDay" style="width: 500px">
          <div class="flex tips">活动开始前
            <el-input v-model="form.differDay" placeholder="14" type="number" :min="0" :disabled="disabled" style="width:50px !important;margin: 0 10px" oninput="value=value.replace('/^[1-9]\d*$/','');if(value<0)value=0" @keydown.native="handleFixNaN" />天
          </div>
        </el-form-item>
        <el-form-item label="截止报名时间" prop="registrationIsOver" style="width: 500px">
          <div class="flex tips">活动开始前
            <el-input v-model="form.registrationIsOver" placeholder="01" type="number" :min="0" :disabled="disabled" style="width:50px !important;margin: 0 10px" oninput="value=value.replace('/^[1-9]\d*$/','')" @keydown.native="handleFixNaN" />天
          </div>
        </el-form-item>
        <el-form-item label="计算活动时长" prop="isCalculationDuration">
          <el-radio-group v-model="form.isCalculationDuration" :disabled="disabled">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="form.isTeamEvent === 1 && form.uaraEventTypeId === 4" class="row-cont">
          <el-form-item label="报名队伍数" prop="teamNum" style="width:300px">
            <el-input v-model.number="form.teamNum" type="number" placeholder="请输入报名队伍数" maxlength="9" @input="value => form.teamNum = parseInt(value)" @change="changeTeamNum" />
          </el-form-item>
        </div>
        <el-form-item v-if=" form.uaraEventTypeId === 4 " ref="uaraStartRunningTimes" :label="form.isTeamEvent === 0 ? '配置开跑时间及人数' : '配置开跑时间及队伍'" prop="uaraStartRunningTimes" style="width: 700px;user-select: none;" label-width="150px">
          <template v-for="(item, index) in form.uaraStartRunningTimes">
            <div :key="index">
              <el-time-picker v-model="item.time" is-range range-separator="-" :picker-options="{ format:'HH:mm' }" start-placeholder="开跑起始时间" value-format="HH:mm:00" end-placeholder="开跑结束时间" placeholder="选择时间范围" style="width:300px;margin-bottom:15px;" />
              <el-input v-model="item.applyNum" type="number" :placeholder="form.isTeamEvent === 0 ? '限制人数' : '限制队伍数'" style="width: 100px;margin:0 5px 0 20px" :disabled="disabled" />{{ form.isTeamEvent === 0 ? '人' : '队' }}
            </div>
          </template>
        </el-form-item>

        <div v-if="form.isTeamEvent === 1 && form.uaraEventTypeId === 4" class="row-cont">
          <el-form-item label="组队最大人数" prop="maxTeamPeople" style="width:300px">
            <el-input v-model.number="form.maxTeamPeople" type="number" placeholder="请输入组队最大人数" maxlength="9" @input="value => form.maxTeamPeople = parseInt(value)" />
          </el-form-item>
          <el-form-item label="组队最小人数" prop="minTeamPeople" style="width:300px">
            <el-input v-model.number="form.minTeamPeople" type="number" placeholder="请输入组队最小人数" maxlength="9" @input="value => form.minTeamPeople = parseInt(value)" @blur="checkMaxOrMinTeam('maxTeamPeople')" />
          </el-form-item>
        </div>
        <el-form-item v-if=" form.uaraEventTypeId === 2 || form.uaraEventTypeId === 3 || form.uaraEventTypeId === 4" label="活动介绍" prop="content" style="width: 80%">
          <el-input v-model="form.content" type="textarea" :rows="4" placeholder="请输入活动介绍" :disabled="disabled" />
        </el-form-item>
        <el-form-item v-if=" form.uaraEventTypeId === 2 || form.uaraEventTypeId === 3 || form.uaraEventTypeId === 4" label="注意事项" prop="precautions" style="width: 80%">
          <el-input v-model="form.precautions" type="textarea" :rows="4" placeholder="请输入注意事项" :disabled="disabled" />
        </el-form-item>
        <el-form-item v-if="form.uaraEventTypeId === 3" label="备注" prop="remark" style="width: 80%">
          <el-input v-model="form.remark" type="textarea" :rows="4" placeholder="请输入备注" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="是否在列表页展示" prop="isShow" label-width="140px">
          <el-radio-group v-model="form.isShow" :disabled="disabled">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传图片" prop="activityImageVO" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage :url="form.activityImageVO.activityListPagePicture" title="列表页图片" size-tips="360px*576px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'activityListPagePicture')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.activityImageVO.activityDetailsPageHeader" title="详情页头图" size-tips="1125px*1125px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'activityDetailsPageHeader')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.activityImageVO.shareCardImage" title="小程序分享卡片" size-tips="500px*400px" :limit-size="2" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'shareCardImage')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.activityImageVO.shareImage" title="海报分享图片" size-tips="849px*849px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'shareImage')" @triggerReg="handleCheckReg" />
          </div>
        </el-form-item>
        <div class="flex btns">
          <el-button type="info" @click="cancel">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>

<script>
import { UaraActivity } from '@/model/UaraActivity';
import UploadImage from '@/components/UploadImage';
import { mapState } from 'vuex';
import Dialog from '@/components/Dialog';
import CoachSelect from "./select.vue";
import { getFileType } from '@/common/js/util';

export default {
  components: { UploadImage, Dialog, CoachSelect },
  data() {
    const checkCoachSelectVO = (rule, value, callback) => {
      if (value && value.length) {
        const ids = [];
        value.some((item) => {
          if (item.id && ids.includes(item['id'])) {
            callback(new Error('请选择不重复的课程教练'));
          }
          ids.push(item['id']);
        });
      }
      callback();
    };
    return {
      form: new UaraActivity(),
      rules: {
        isTeamEvent: [
          { required: true, message: '请选择报名方式', trigger: 'change' },
        ],
        uaraEventTypeId: [
          { required: true, message: '请选择活动类型', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入活动主标题', trigger: 'blur' },
        ],
        uaEventCityId: [
          { required: true, message: '请输入活动城市', trigger: 'change' },
        ],
        exportTime: [
          { type: 'array', required: true, message: '请选择招募时间', trigger: ['change', 'blur'] },
        ],
        otherAddress: [
          { required: true, message: '请输入活动地址', trigger: 'blur' },
        ],
        location: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === '0,0') {
                callback(new Error('请输入经纬度'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        coachSelectVO: [
          { required: false, message: "请选择课程教练", trigger: ["blur"] },
          { validator: checkCoachSelectVO, trigger: 'change' },
        ],
        activityTime: [
          { type: 'array', required: true, message: '请输入活动时间', trigger: ['change', 'blur'] },
        ],
        isSpeciallyInvite: [
          { required: true, message: '请选择是否为特邀', trigger: 'change' },
        ],
        isSecondaryScreening: [
          { required: true, message: '请选择是否进行二次筛选', trigger: 'change' },
        ],
        excelName: [
          { required: true, message: '请上传文件', trigger: 'change' },
        ],
        competition: [
          { required: true, message: '请输入比赛日期', trigger: 'blur' },
        ],
        numberOfRecruits: [
          {
            required: true, validator: (rule, value, callback) => {
              const msg = this.form.isTeamEvent === 0 ? "请输入招募人数" : "请输入招募队伍数";
              if (value === null || value === undefined) {
                callback(new Error(msg));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        teamNum: [
          { required: true, message: '请输入报名队伍数', trigger: 'blur' },
        ],
        maxTeamPeople: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === undefined || value === null) {
                callback(new Error('请输入组队最大人数'));
              } else if (value && this.form.minTeamPeople && value < this.form.minTeamPeople) {
                callback(new Error('请大于组队最小人数'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        minTeamPeople: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === undefined || value === null) {
                callback(new Error('请输入组队最小人数'));
              } else if (value && this.form.maxTeamPeople && value > this.form.maxTeamPeople) {
                callback(new Error('请小于组队最大人数'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        participationNumber: [
          { required: true, message: '请输入报名人数', trigger: 'blur' },
        ],
        alternateTotalNumber: [
          { required: true, message: '请输入候补人数', trigger: 'blur' },
        ],
        courseArrangementImg: [
          { required: true, message: '请上传课程安排', trigger: 'blur' },
        ],
        explanation: [
          { required: false },
        ],
        remark: [
          { required: false },
        ],
        interview: {
          required: true, validator: (rule, value, callback) => {
            const objKeys = Object.keys(value);
            if (value[objKeys[0]] === null) {
              callback(new Error('请选择面试时间'));
            } else if (value[objKeys[1]] === '') {
              callback(new Error('请输入详细描述'));
            } else {
              callback();
            }
          }, trigger: ['change', 'blur'],
        },
        differDay: [
          { required: false },
        ],
        registrationIsOver: [
          { required: false },
        ],
        isCalculationDuration: [
          { required: true, message: '请选择是否计算活动时长', trigger: 'change' },
        ],
        isShow: [
          { required: true, message: '请选择是否在列表页展示', trigger: 'change' },
        ],
        activityImageVO: {
          required: true, validator: (rule, value, callback) => {
            const keys = [
              { key: 'activityListPagePicture', label: '列表页图片' },
              { key: 'activityDetailsPageHeader', label: '详情页头图' },
              { key: 'shareCardImage', label: '小程序分享卡片' },
              { key: 'shareImage', label: '海报分享图片' },
              // { key: 'recommendedPcturesOfRelevantActivities', label: '相关活动推荐图片' },
              // { key: 'myActivityListPictures', label: '我的活动列表页图片' },
            ];
            value.myActivityListPictures = ' ';
            value.recommendedPcturesOfRelevantActivities = ' ';

            for (const { key, label } of keys) {
              if (!value[key]) {
                callback(new Error(`请上传${label}`));
              }
            }
            callback();
          }, trigger: ['change'],
        },
        uaraStartRunningTimes: {
          required: true, validator: (rule, value, callback) => {
            const array = [];
            const bool = this.form.isTeamEvent === 0;
            for (const key in value) {
              array.push(value[key]);
            }
            if (array.some((item) => !item.time)) {
              callback(new Error('请选择完整开跑时间'));
            } else if (array.some((item) => item.applyNum === '')) {
              const msg = this.form.isTeamEvent === 0 ? '请输入开跑人数' : '请输入开跑队伍数';
              callback(new Error(msg));
            } else {
              const total = array.reduce((sum, e) => sum + Number(e.applyNum || 0), 0);
              // 个人
              if (bool) {
                if (this.form.participationNumber && total <= Number(this.form.participationNumber)) {
                  callback();
                } else {
                  this.$refs.form.validateField("participationNumber");
                  callback(new Error('选择人数不能大于报名人数'));
                }
              } else {
                if (this.form.teamNum && total <= Number(this.form.teamNum)) {
                  callback();
                } else {
                  this.$refs.form.validateField("participationNumber");
                  callback(new Error('选择队伍不能大于报名队伍'));
                }
              }
            }
          }, trigger: ['change', 'blur'],
        },
        content: [
          { required: true, message: '请输入活动介绍', trigger: 'blur' },
        ],
        competitionRules: [
          { required: true, message: '请输入赛事规则', trigger: 'blur' },
        ],
        precautions: [
          { required: true, message: '请输入注意事项', trigger: 'blur' },
        ],
      },
      cancelText: "",
      information: {},
      activityStatus: [],
      disabled: false,
      savePath: "uara-activity/add",
      formDialogShow: false,
    };
  },
  computed: {
    ...mapState('activity', ['citySelectVO', 'coachSelectVO']),
  },
  watch: {
    "form.uaraEventTypeId": function (newVal, oldVal) {
      const oldIsTeamEvent = this.form.isTeamEvent;
      if (this.cancelText === '新增') {
        this.form = new UaraActivity();
        this.form.uaraEventTypeId = newVal;
        this.form.isTeamEvent = oldIsTeamEvent;
        this.$refs.form.clearValidate();
      }
    },
    "form.isSpeciallyInvite": {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal === 1) {
          this.form.isSecondaryScreening = 0;
        }
      },

    },
    "form.isTeamEvent": {
      deep: true,
      handler(newVal, oldVal) {
        this.$refs.form.clearValidate();
      },
    },
  },

  created() {
    this.getListType();
  },
  mounted() {
    const { query } = this.$route;
    this.id = query.id;
    if (query.id) {
      this.cancelText = '编辑';
      this.getUaraDetail(this.id);
    } else {
      this.cancelText = '新增';
    }
  },
  methods: {
    getListType() {
      this.$Api.uara.getUaraTypeList().then(res => {
        this.activityStatus = res;
      });
    },
    handleChangeDisabled(e) {
      this.form.isNeedCoach = e ? 1 : 0;
    },
    changeParticipationNumber() {
      const flag = this.form.uaraStartRunningTimes.some((item) => item.applyNum);
      if (flag) this.$refs.form.validateField("uaraStartRunningTimes");
    },
    changeTeamNum() {
      const flag = this.form.uaraStartRunningTimes.some((item) => item.applyNum);
      if (flag) this.$refs.form.validateField("uaraStartRunningTimes");
    },
    getUaraDetail(id) {
      this.$Api.uara.getItemUaradetail(id).then(res => {
        this.form = new UaraActivity(res);
        if (res.uaraStartRunningTimes.length === 0) {
          this.form.uaraStartRunningTimes = [{}, {}];
        }
      });
    },
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意活动状态，保存后已发布的活动信息将实时更新至UA HOUSE小程序",
      };
    },
    dialogSuccess(operation) {
      if (operation === 'cancel') {
        this.$router.go(-1);
      } else if (operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.addEditItem();
          } else {
            return false;
          }
        });
      }
    },
    addRunningTime() {
      this.form.uaraStartRunningTimes.push({ time: null });
    },
    addEditItem() {
      if (this.form.uaraEventTypeId === 4) this.form.setUaraStartRunningTimes();// 格式化时间
      this.form.setNumTypeIdOne();// 格式化报名数

      const formData = new FormData();
      const param = { ...this.form, ...this.form.interview };
      if (this.id) param['id'] = this.id;
      // 处理无教练活动
      if (param.isNeedCoach === 1) {
        delete param.coachIds;
      }
      // 组队活动删除报名人数 候补人数
      if (param.isTeamEvent === 1) {
        delete param.participationNumber;
        delete param.alternateTotalNumber;
      }
      // 培训和万米默认需要二次筛选
      if (param.uaraEventTypeId === 1 || param.uaraEventTypeId === 5) {
        param.isSecondaryScreening = 1;
      }
      param.coachIds = [];
      param.coachSelectVO.forEach((item, index) => {
        item.id && param.coachIds.push(item.id);
        if (item.id && item.level && !param.coachLevel) {
          param.coachLevel = item.level;
        } else if (param.coachSelectVO.length === 1 && item.level) {
          param.coachLevel = item.level;
        }
      });
      delete param.coachSelectVO;

      formData.append('file', this.form.file || null);
      delete param.file;
      formData.append('uaraEditDTO', new Blob([JSON.stringify(param)], { type: 'application/json' }));
      console.log('param', param);
      // if (param) {
      //   console.log('param', param);
      //   return;
      // }
      if (this.cancelText === '新增') {
        this.$Api.uara.addUaraList(formData).then(res => {
          this.$message.success(this.cancelText + '成功');
          this.$router.go(-1);
        });
      } else if (this.cancelText === '编辑') {
        this.$Api.uara.editUaraList(formData).then(res => {
          this.$message.success(this.cancelText + '成功');
          this.$router.go(-1);
        });
      }
    },
    openMap() {
      window.open('https://lbs.qq.com/getPoint/');
    },
    handleCheckReg(val) {
      this.$refs.form.validateField("activityImageVO");
    },
    topUploader(file, key) {
      this.form[key] = file;
      this.$forceUpdate();
    },
    uploader(file, key) {
      this.form.activityImageVO[key] = file;
      this.$forceUpdate();
    },
    handleFixNaN(e) {
      const { key } = e;
      if (key === 'e' || key === '.') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 测试最大最小团队数量/团队人数
    checkMaxOrMinTeam(key) {
      this.$refs.form.validateField([key], valid => {
        if (valid) {
          // 校验不通过
          return;
        }
      });
    },
    // 导入用户名单
    importCoupons(file) {
      if (getFileType(file.raw.name) !== 'excel') {
        this.$message.error('导入失败，请选择Excel文件');
        this.$refs.uploader.clearFiles();
        return;
      }
      this.$Api.uploadFile.uploadExcel(file.raw, 'uara/detail/').then(data => {
        this.uploadLoading = false;
        this.form.file = file.raw;
        this.form.excelName = file.raw.name;
        this.form.url = data;
        this.$message.success('上传成功');
        this.uploadedFile = true;
      }).catch(err => {
        this.form.file = null;
        this.form.excelName = '';
        this.form.url = '';
        console.error(err);
      });
    },
    downloadFileTemplate() {
      // 下载
      window.open('https://uadev-1257321318.file.myqcloud.com/static/excelactivityUserListTemplate.xlsx-1646222983676.xlsx');
    },
  },
};
</script>

<style lang="less" scoped>
.row-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.marginTop {
  margin-top: 30px;
}
.btns {
  button {
    width: 120px;
    height: 50px;
  }
  align-items: center;
  justify-content: center;
}
</style>

<style lang="less">
.uara-activity-view {
  .peopleNums {
    min-width: 1000px;
    display: flex;
    align-items: flex-start;
    .peopleNums-box {
      display: flex;
      align-items: flex-start;
    }
    button {
      margin-left: 30px;
    }
  }
  .image-config {
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.btn-reset {
  margin-left: 10px;
  cursor: pointer;
  font-family: "Noto Sans SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0085d0;
}
.form-add {
  margin-top: 24px;
  .el-button {
    border: 1px dashed #bbbbbb;
    i {
      color: #bbbbbb;
    }
    span {
      color: #bbbbbb;
    }
  }
}
.form-icon {
  margin-left: 10px;
  .el-icon-close {
    color: #9b9b9b;
    cursor: pointer;
    &:hover {
      color: #000000;
    }
  }
}
</style>
